import React, { SVGProps } from 'react';
import { SvgContainer } from '@/components/icon/SvgContainer';

export const SendIcon = (props: SVGProps<SVGSVGElement>) => (
  <SvgContainer {...props}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
    />
  </SvgContainer>
);
